export default __webpack_public_path__ + "static/media/logo.5535f869.png";